export default __webpack_public_path__ + "static/media/location-modal-illustration.3158a850.png";